import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import ContractsTable from './ContractsTable';

import { modalOptions } from 'Helpers/modalOptions';

import Modal from 'CommonComponents/Modal';

import useApiRequest from 'Hooks/useApiRequest';
import useModal from 'Hooks/useModal';

const RevenueContractsModal = ({ fetchRevenueContractsUrl, type }) => {
    const [revenueId, setRevenueId] = useState(document.getElementById('RevenueContractsModalApp').getAttribute('data-revenue-id'));
    const [contracts, setContracts] = useState([]);

    const modal = useModal({
        options: {
            ...modalOptions(true),
            backdrop: 'dynamic',
        },
    });

    const revenueContractsRequest = useApiRequest({
        url: fetchRevenueContractsUrl,
    });

    useEffect(() => {
        const targetNode = document.getElementById('RevenueContractsModalApp');

        // Callback function to execute when mutations are observed
        const callback = function (mutationsList, observer) {
            for (const mutation of mutationsList) {
                if (mutation.type === 'attributes') {
                    if (mutation.attributeName === 'data-revenue-id') {
                        const newRevenueId = mutation.target.getAttribute('data-revenue-id');
                        setRevenueId(newRevenueId);

                        modal.show();
                    }
                    if (mutation.attributeName === 'data-show') {
                        const newShow = mutation.target.getAttribute('data-show');

                        if (newShow === 'true') {
                            modal.show();
                            if (!contracts.length) {
                                fetchContracts();
                            }
                        } else {
                            modal.hide();
                        }
                    }
                }
            }
        };

        // Create an observer instance linked to the callback function
        const observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(targetNode, { attributes: true });

        // Cleanup function to stop observing when the component unmounts
        return () => {
            observer.disconnect();
        };
    }, [contracts]);

    useEffect(() => {
        setContracts(revenueContractsRequest.data?.data || []);
    }, [revenueContractsRequest.data]);

    useEffect(() => {
        if (revenueId) {
            fetchContracts(revenueId);
        }
    }, [revenueId]);

    const fetchContracts = (revenueId = null) => {
        if (type === 'ticketing') {
            fetchTicketingContracts();
            return;
        }

        revenueContractsRequest.get(null, { REVENUE_ID: revenueId });
    };

    const fetchTicketingContracts = () => {
        revenueContractsRequest.get();
    };

    return (
        <Modal id="revenue-contracts-modal" modal={modal} innerContainerClasses="tw-bg-[#F8F8F8]" containerStyle={{ maxWidth: 'none', width: 'auto' }}>
            <ContractsTable isLoading={revenueContractsRequest.loading} contracts={contracts} />
        </Modal>
    );
};

if (document.getElementById('RevenueContractsModalApp')) {
    var rootEl = document.getElementById('RevenueContractsModalApp');
    var fetchRevenueContractsUrl = rootEl.getAttribute('data-fetch-revenue-contracts-url');
    var type = rootEl.getAttribute('data-type');
    ReactDOM.render(
        <App>
            <RevenueContractsModal fetchRevenueContractsUrl={fetchRevenueContractsUrl} type={type} />
        </App>,
        rootEl,
    );
}
